import { sagaMiddleware } from './middlewares'
import { rootSaga } from './sagas'

sagaMiddleware.run(rootSaga)

export * from './store'
export * from './hooks'
